import React from "react";
import googleReviews from "../../assets/googlereviews.png";
import yelpReviews from "../../assets/yelpreviews.png";

function FourStarThanks() {
  return (
    <div
      className="text-center p-4 shadow-sm border"
      style={{
        backgroundColor: "white",
        fontFamily: "cambria",
        fontSize: "18px",
        padding: "30px",
      }}
    >
      <h3>Thank You for Your Positive Feedback!</h3>
      <p className="small-text">
        We're glad you had a great experience! If you'd like, you can leave a
        review:
      </p>
      <div className="row">
        <div className="col">
          <a
            className="text-center"
            href="https://g.page/r/Cbjts0N_Ws6_EB0/review"
          >
            <div>
              <img
                src={googleReviews}
                className="rounded-circle"
                width={120}
                style={{ border: "3px dashed rgb(115, 185, 255)" }}
                alt=""
              />
            </div>
            <small>Leave a Google review</small>
          </a>
        </div>
        <div className="col">
          <a
            href="https://www.yelp.com/writeareview/biz/0eqe6VK_yvHgclMjLeRnzw?return_url=%2Fbiz%2F0eqe6VK_yvHgclMjLeRnzw&review_origin=biz-details-war-button"
            className="text-center"
          >
            <div>
              <img
                src={yelpReviews}
                className="rounded-circle"
                style={{ border: "3px dashed rgb(115, 185, 255)" }}
                width={120}
                alt=""
              />
            </div>
            <small>Leave a Yelp review</small>
          </a>
        </div>
      </div>
    </div>
  );
}

export default FourStarThanks;
